import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const services = [{
  name: 'Knotless Braids',
  price: '$180.00',
  image: 'https://cdn.magicpatterns.com/uploads/3kUPkGrZf1j7p79xt5GkLh/unnamed_(5).webp'
}, {
  name: 'Goddess Braids',
  price: '$150.00',
  image: 'https://cdn.magicpatterns.com/uploads/ptdadMo8NPeQ6XnMdY69mH/unnamed_(4).webp'
}, {
  name: 'Cornrows with Design',
  price: '$90.00',
  image: 'https://cdn.magicpatterns.com/uploads/crCTSmWDU5nbKxFsRHbc9a/WhatsApp_Image_2026-03-27_at_7.53.57_PM.jpg'
}];
export function HomeServices() {
  return <section id="services" className="py-24 bg-cream text-near-black" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-6" data-id="element-172">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-warm-brown shrink-0" data-id="element-173">
            Our Services
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-near-black/70 font-body text-sm md:text-base max-w-xl leading-relaxed" data-id="element-174">
            Whether you're going for a protective look, a bold transformation,
            or a signature everyday style — our expert braiders have you
            covered.
          </motion.p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-175">
          {services.map((service, index) => <motion.a href="tel:2409217857" key={service.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group block" data-id="element-176">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-4 bg-warm-brown/5" data-id="element-177">
                <img src={service.image} alt={service.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-178" />
                <div className="absolute top-4 left-4 bg-cream/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest text-warm-brown" data-id="element-179">
                  {service.name.includes('Cornrows') ? 'Cornrows' : 'Braids'}
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-180">
                <h3 className="font-display text-2xl text-warm-brown group-hover:text-brand-gold transition-colors" data-id="element-181">
                  {service.name}
                </h3>
              </div>
            </motion.a>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-182">
          <Link to="/services" className="inline-flex items-center justify-center px-8 py-3 bg-warm-brown text-cream font-bold text-sm rounded-full hover:bg-near-black transition-colors shadow-md" data-id="element-183">
            View Full Service Menu
          </Link>
        </motion.div>
      </div>
    </section>;
}